/* ============================================
   CART DRAWER JS - Dawn compatible
   Uses Shopify Ajax Cart API (no jQuery)
   ============================================ */

(function () {
  'use strict';

  /* ── Bundle discount (CLAYJOY4/6/8) ────── */
  const BUNDLE_TIERS = [
    { minQty: 8, code: 'CLAYJOY8', save: 30 },
    { minQty: 6, code: 'CLAYJOY6', save: 15 },
    { minQty: 4, code: 'CLAYJOY4', save:  5 },
  ];

  // Колко кита = 100% запълнена лента. 8 кита → всеки кит добавя 12.5%.
  const BUNDLE_MAX_KITS = 8;

  // Резервни цветове — ползват се САМО ако Theme Editor настройката липсва
  // или е невалидна (празна, прозрачна и т.н.). Иначе цветовете идват от
  // Theme Editor → Cart Drawer → „Цвят на незапълнена/запълнена лента“.
  const CD_FALLBACK_EMPTY = '#E6E6E6';
  const CD_FALLBACK_FILL  = '#5BBA17';

  /* ── helpers ──────────────────────────────── */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  // Used only for the free-shipping progress line: "€ 14.04" (space + dot)
  function formatMoneySpaced(cents) {
    return '€ ' + (cents / 100).toFixed(2);
  }

  // Пази ни от невидима лента: ако цветът от Theme Editor е празен, "transparent",
  // "none" или напълно прозрачен rgba/8-цифрен hex с alpha 00, връщаме резервния
  // цвят вместо да боядисаме лентата в нищо. Точно това би изглеждало като
  // „лентата не расте“ — тя расте, но е прозрачна върху сивия фон.
  function sanitizeColor(value, fallback) {
    if (typeof value !== 'string') return fallback;
    var v = value.trim();
    if (!v) return fallback;
    var low = v.toLowerCase();
    if (low === 'transparent' || low === 'none' || low === 'initial' ||
        low === 'inherit' || low === 'unset' || low === 'currentcolor') return fallback;
    if (low.replace(/\s+/g, '') === 'rgba(0,0,0,0)') return fallback;
    // #RRGGBBAA / #RGBA с нулева непрозрачност
    if (/^#[0-9a-f]{8}$/.test(low) && low.slice(7) === '00') return fallback;
    if (/^#[0-9a-f]{4}$/.test(low) && low.slice(4) === '0')  return fallback;
    return v;
  }

  /* ── state ───────────────────────────────── */
  let cart = null;
  let isOpen = false;
  let shakeTimer = null; // изчиства класа на анимацията, за да може да се пусне пак
  let cartRequestToken = 0; // guards against out-of-order /cart responses when the user clicks fast

  // Желаното количество за всеки вариант (variant_id -> брой), докато клиентът
  // още кликa или заявката пътува. Докато тук има стойност, тя се показва в
  // количката вместо числото от сървъра — така отговор на по-стара заявка не
  // връща брояча назад под пръста на клиента.
  const pendingQty = new Map();

  // Всяка мутация на количката (qty промяна, remove, upsell add) минава последователно
  // през тази опашка — никога две /cart/*.js заявки едновременно. Без това, махането
  // на два различни артикула бързо един след друг може да доведе до отхвърляне на
  // валиден, вече обработен от Shopify отговор само защото друга заявка е тръгнала
  // междувременно — реалната промяна се случва в Shopify, но UI-то никога не я показва.
  let cartMutationQueue = Promise.resolve();
  let cartBusyCount = 0;
  let drawerOpener = null;
  const productPrices = new Map();
  const productRequests = new Map();
  const loadedProducts = new Set();
  function queueCartMutation(task) {
    cartBusyCount += 1;
    updateCheckoutState();
    const run = cartMutationQueue.then(task, task);
    const settled = run.finally(() => {
      cartBusyCount -= 1;
      updateCheckoutState();
    });
    cartMutationQueue = settled.catch(() => {});
    return settled;
  }

  /* ── DOM refs (set after DOMContentLoaded) ─ */
  let drawer, overlay, floatBtn, badge,
      itemsWrap, progressFill, progressText,
      progressTruck, totalAmount,
      discountInput, discountBtn, discountMsg,
      upsellScroll,
      sumSubtotal, sumShippingVal, sumDiscountRow, sumDiscountVal;

  /* Bundle DOM refs */
  let bundleBar, bundleFill, bundleTrack, bundleText,
      bundleMs2, bundleMs4, bundleMs6, bundleMs8,
      bundleToggle, bundlePanel, bundleChevron;
  let bundleCurrentCode = null;
  let bundleApplying    = false;
  let bundleOpen        = false;

  /* ── thresholds from data attrs ───────── */
  function getThreshold() {
    const el = $('#cd-drawer');
    return el ? parseInt(el.dataset.threshold || '4000', 10) : 4000;
  }

  function getProgressColors() {
    const el = $('#cd-drawer');
    return {
      empty: sanitizeColor(el ? el.dataset.colorEmpty : '', CD_FALLBACK_EMPTY),
      fill:  sanitizeColor(el ? el.dataset.colorFill  : '', CD_FALLBACK_FILL),
    };
  }

  function getTexts() {
    const el = $('#cd-drawer');
    return {
      before: el ? (el.dataset.textBefore || 'Още {amount} до БЕЗПЛАТНА доставка до офис!') : 'Още {amount} до БЕЗПЛАТНА доставка до офис!',
      after:  el ? (el.dataset.textAfter  || 'Имаш безплатна доставка! 🎉')        : 'Имаш безплатна доставка! 🎉',
    };
  }

  // Дали количката да се отваря сама при добавяне на продукт. Стойността идва
  // от Theme Editor → Cart Drawer → „Отваряй количката при добавяне“.
  // По подразбиране е ИЗКЛЮЧЕНО: клиентът остава на страницата и продължава да
  // разглежда, а сигналът за добавяне е разклащане на плаващия бутон.
  function getAutoOpen() {
    const el = $('#cd-drawer');
    return !!el && el.dataset.autoOpen === 'true';
  }

  // Theme Editor пре-рендерира секцията при всяка промяна на настройка, така че
  // старата препратка към бутона може да сочи към откачено DOM дърво. Взимаме я
  // наново, ако вече не е в живия документ.
  function getFloatBtn() {
    if (!alive(floatBtn)) floatBtn = $('#cd-float-btn');
    return floatBtn;
  }

  function setFloatBtnHidden(hidden) {
    const btn = getFloatBtn();
    if (!btn) return;
    btn.classList.toggle('is-hidden', !!hidden);
    if (hidden) btn.classList.remove('is-shaking');
  }

  // Визуалният сигнал при добавяне: жълтият таб се разклаща и червеният брояч
  // подскача. Класът се маха след края на анимацията, за да може следващото
  // добавяне да я пусне отначало (иначе вторият клик не би направил нищо).
  function shakeCart() {
    const btn = getFloatBtn();
    if (!btn) return;
    btn.classList.remove('is-shaking');
    void btn.offsetWidth; // reflow — рестартира анимацията
    btn.classList.add('is-shaking');
    if (shakeTimer) clearTimeout(shakeTimer);
    shakeTimer = setTimeout(function () {
      if (alive(btn)) btn.classList.remove('is-shaking');
    }, 700);
    if (alive(badge)) {
      badge.classList.remove('bump');
      void badge.offsetWidth;
      badge.classList.add('bump');
    }
  }

  /* ── open / close ──────────────────────── */
  function openDrawer() {
    if (!drawer || !document.contains(drawer)) init();
    if (!drawer) return;
    if (!isOpen) drawerOpener = document.activeElement;
    isOpen = true;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    setFloatBtnHidden(true);
    document.body.style.overflow = 'hidden';
    drawer.setAttribute('aria-hidden', 'false');
    const close = $('#cd-close-btn');
    if (close) close.focus({ preventScroll: true });
    fetchCart();
  }

  function closeDrawer() {
    if (!drawer) return;
    isOpen = false;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    setFloatBtnHidden(false);
    document.body.style.overflow = '';
    drawer.setAttribute('aria-hidden', 'true');
    if (drawerOpener && document.contains(drawerOpener)) drawerOpener.focus({ preventScroll: true });
  }

  /* ── fetch cart ────────────────────────── */
  // fetchCartInner() е реалната работа, БЕЗ да опашкува себе си — вика се от код,
  // който вече тече вътре в опашката (напр. onUpsellAdd), за да не се самозаключи
  // (task, който чака ред след себе си, никога не би получил ред).
  async function fetchCartInner() {
    const myToken = ++cartRequestToken;
    try {
      const res = await fetch('/cart.js');
      let data = await res.json();
      if (isValidCart(data)) data = await normalizePairDiscount(data);
      if (myToken !== cartRequestToken) return; // defensive - should never trigger once queued
      if (isValidCart(data)) {
        if (isOpen) await loadProductPrices(data.items);
        if (myToken !== cartRequestToken) return;
        cart = data;
        renderCart();
      }
    } catch (e) {
      console.error('[CartDrawer] fetchCart error', e);
    }
  }

  // fetchCart() е публичният вход — вика се ОТВЪН всякаква опашка (при отваряне на
  // drawer-а, от глобалния add-to-cart hook, от cart:updated event-а). showSkeleton()
  // е извън опашката нарочно — потребителят вижда мигновен loading отклик веднага,
  // дори ако вече чака ред друга мутация (напр. quick-add "+" върху продуктова карта
  // в grid-а, засечен от глобалния fetch hook по-долу).
  function fetchCart() {
    showSkeleton();
    return queueCartMutation(fetchCartInner);
  }

  /* ── render ───────────────────────────── */
  // Shopify връща error обект {status, message, description} БЕЗ items при 422/невалидна
  // заявка (напр. невалиден line key при бързо add+remove). Валиден cart ВИНАГИ има
  // items масив. Без тази проверка updateBundleBar прави cart.items.reduce() върху
  // undefined → хвърля → цялата render верига се къса → барът замръзва на стар state,
  // докато DOM брояча показва оптимистичното число. Точно това чупеше количката.
  function isValidCart(obj) {
    return obj && Array.isArray(obj.items) && typeof obj.item_count === 'number';
  }

  function loadProductPrices(items) {
    const handles = [...new Set(items.map(item => item.handle).filter(Boolean))];
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return Promise.all(handles.map(handle => {
      if (loadedProducts.has(handle)) return Promise.resolve();
      if (!productRequests.has(handle)) {
        const request = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
          headers: { Accept: 'application/json' },
          signal: AbortSignal.timeout(2500),
        }).then(response => {
          if (!response.ok) throw new Error('Product price unavailable');
          return response.json();
        }).then(product => {
          (product.variants || []).forEach(variant => {
            productPrices.set(String(variant.id), {
              price: variant.price,
              compareAt: variant.compare_at_price,
            });
          });
          loadedProducts.add(handle);
        }).catch(() => {}).finally(() => productRequests.delete(handle));
        productRequests.set(handle, request);
      }
      return productRequests.get(handle);
    }));
  }

  function compareAtFor(item) {
    const productPrice = productPrices.get(String(item.variant_id));
    if (!productPrice || !Number.isFinite(productPrice.compareAt) ||
        !Number.isFinite(productPrice.price) ||
        productPrice.price !== item.original_price ||
        productPrice.compareAt <= productPrice.price) return 0;
    return productPrice.compareAt;
  }

  function itemPriceHTML(item) {
    const compareAt = compareAtFor(item);
    const current = formatMoney(item.final_line_price);
    if (!compareAt) return current;
    return '<s class="cd-item__compare">' + formatMoney(compareAt * item.quantity) +
      '</s><span class="cd-item__price-now">' + current + '</span>';
  }

  // Всяка стъпка е в свой try/catch: ако една се счупи (напр. липсва скритият
  // .cd-progress блок), останалите ПАК се изпълняват. Преди това една грешка в
  // updateProgress() спираше цялата верига и bundle лентата никога не се обновяваше.
  function safe(label, fn) {
    try { fn(); } catch (e) { console.error('[CartDrawer] ' + label, e); }
  }

  function renderCart() {
    if (!isValidCart(cart)) return;
    updateCheckoutState();
    safe('updateBadge',      function () { updateBadge(cart.item_count); });
    safe('updateProgress',   function () { updateProgress(cart.total_price); });
    safe('updateBundleBar',  function () { updateBundleBar(cart.items, cart.total_price); });
    safe('applyBundleDiscount', function () { applyBundleDiscount(cart.item_count); });
    safe('renderItems',      function () { renderItems(cart.items); });
    safe('renderSummary',    function () { renderSummary(cart); });
    safe('renderTotal',      function () { renderTotal(cart.total_price); });
    safe('renderUpsell', function () {
      const offer = $('#cj-cart-upsell');
      if (!offer) return;
      offer.hidden = !pairOfferState(cart).eligible;
      const receipt = $('#cj-cu-status');
      if (!pairAdding && receipt && !receipt.hidden && !receipt.classList.contains('is-error') &&
          (pairOfferState(cart).count !== 3 || !receipt.textContent.includes(formatMoney(cart.total_price)))) {
        pairStatus('', false);
      }
    });
  }

  function updateBadge(count) {
    if (!badge) return;
    var safeCount = Number.isFinite(count) ? count : 0;
    badge.textContent = safeCount;
    badge.style.display = safeCount > 0 ? 'flex' : 'none';
    badge.classList.remove('bump');
    void badge.offsetWidth; // reflow
    badge.classList.add('bump');

    // update drawer header count
    const headerCount = $('#cd-header-count');
    if (headerCount) headerCount.textContent = `(${safeCount})`;
    const headerCart = $('#cart-icon-bubble');
    if (headerCart) {
      let bubble = $('.cart-count-bubble', headerCart);
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        headerCart.appendChild(bubble);
      }
      bubble.hidden = safeCount === 0;
      bubble.style.display = safeCount === 0 ? 'none' : '';
      const number = $('[aria-hidden="true"]', bubble);
      const label = $('.visually-hidden', bubble);
      if (number) number.textContent = safeCount < 100 ? String(safeCount) : '99+';
      if (label) label.textContent = safeCount + (safeCount === 1 ? ' артикул' : ' артикула');
    }
  }

  function updateProgress(totalCents) {
    if (!progressFill || !progressText) return;
    const threshold = getThreshold();
    const colors    = getProgressColors();
    const texts     = getTexts();

    progressFill.style.background = colors.fill;
    const legacyTrack = progressFill.closest('.cd-progress__track');
    if (legacyTrack) legacyTrack.style.background = colors.empty;

    const pct = Math.min((totalCents / threshold) * 100, 100);
    progressFill.style.width = pct + '%';

    if (progressTruck) {
      progressTruck.style.right = pct >= 100 ? '-10px' : '-10px';
    }

    if (totalCents >= threshold) {
      progressText.innerHTML = `<strong>${texts.after}</strong>`;
    } else {
      const remaining = formatMoneySpaced(threshold - totalCents);
      progressText.innerHTML = texts.before.replace('{amount}', `<strong>${remaining}</strong>`);
    }
  }

  // Количеството, което се показва за даден ред: желаното от клиента, ако още
  // има чакаща промяна за този вариант, иначе числото от Shopify.
  function shownQty(item) {
    const vid = String(item.variant_id);
    return pendingQty.has(vid) ? pendingQty.get(vid) : item.quantity;
  }

  function renderItems(items) {
    if (!itemsWrap) return;

    // Ред, който клиентът току-що е махнал (желано количество 0), не се рисува.
    const visible = (items || []).filter(item => shownQty(item) > 0);

    if (visible.length === 0) {
      itemsWrap.innerHTML = `
        <div class="cd-empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.836l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.932-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"/>
          </svg>
          <p>Количката е празна</p>
          <a href="/collections/all" class="cj-empty-shop">Избери комплекти</a>
        </div>`;
      return;
    }

    // Ако редовете са същите като вече нарисуваните, обновяваме само числата на
    // място. Така бутоните +/− не се подменят под пръста на клиента (подмяната
    // между натискане и пускане поглъщаше клика) и снимките не премигват.
    const existing = $$('.cd-item', itemsWrap);
    const sameRows = existing.length === visible.length &&
      itemsWrap.children.length === visible.length &&
      existing.every((el, i) => el.dataset.variantId === String(visible[i].variant_id));

    if (sameRows) {
      existing.forEach((el, i) => {
        const item = visible[i];
        el.dataset.key = item.key;
        el.classList.remove('is-removing');
        $$('[data-key]', el).forEach(node => { node.dataset.key = item.key; });
        const qtyEl = $('.cd-item__qty-num', el);
        const qtyText = String(shownQty(item));
        if (qtyEl && qtyEl.textContent !== qtyText) qtyEl.textContent = qtyText;
        const priceEl = $('.cd-item__price', el);
        if (priceEl) {
          priceEl.innerHTML = itemPriceHTML(item);
          priceEl.classList.toggle('cd-item__price--sale', !!compareAtFor(item));
        }
      });
      return;
    }

    itemsWrap.innerHTML = visible.map(item => buildItemHTML(item)).join('');

    // bind qty buttons
    $$('.cd-item__qty-btn', itemsWrap).forEach(btn => {
      btn.addEventListener('click', onQtyClick);
    });
    $$('.cd-item__remove', itemsWrap).forEach(btn => {
      btn.addEventListener('click', onRemoveClick);
    });
  }

  function buildItemHTML(item) {
    const imgSrc = item.image
      ? item.image.replace('http:', 'https:')
      : 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60"%3E%3Crect fill="%23f0f0f0" width="60" height="60"/%3E%3C/svg%3E';

    const variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? `<p class="cd-item__variant">${item.variant_title}</p>`
      : '';

    return `
      <div class="cd-item" data-key="${item.key}" data-variant-id="${item.variant_id}">
        <img class="cd-item__img" src="${imgSrc}" alt="${escapeHtml(item.product_title)}" width="60" height="60" loading="lazy">
        <div class="cd-item__info">
          <p class="cd-item__name">${escapeHtml(item.product_title)}</p>
          ${variant}
          <p class="cd-item__price${compareAtFor(item) ? ' cd-item__price--sale' : ''}">${itemPriceHTML(item)}</p>
          <div class="cd-item__controls">
            <button class="cd-item__qty-btn" data-key="${item.key}" data-action="decrease" aria-label="Намали количеството">−</button>
            <span class="cd-item__qty-num">${shownQty(item)}</span>
            <button class="cd-item__qty-btn" data-key="${item.key}" data-action="increase" aria-label="Увеличи количеството">+</button>
          </div>
        </div>
        <button class="cd-item__remove" data-key="${item.key}" aria-label="Премахни от количката">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>`;
  }

  function renderTotal(totalCents) {
    if (totalAmount) {
      totalAmount.textContent = formatMoney(totalCents);
    }
  }

  // Създава разбивката (Общо / Доставка / Отстъпка) и я вмъква най-отгоре във
  // футъра, точно над реда с крайното "Общо". Прави се през JS нарочно — така
  // core секцията cd-cart-drawer.liquid остава непокътната (по-нисък риск, по-лесно
  // се отменя). Извиква се веднъж от init().
  function buildSummaryDOM() {
    var footer = $('.cd-footer');
    if (!footer) return;
    if ($('#cd-sum-subtotal')) {
      sumSubtotal    = $('#cd-sum-subtotal');
      sumShippingVal = $('#cd-sum-shipping');
      sumDiscountRow = $('#cd-sum-discount-row');
      sumDiscountVal = $('#cd-sum-discount');
      return; // вече вградено — не дублирай
    }
    var totalRow = $('.cd-footer__total', footer);

    var wrap = document.createElement('div');
    wrap.className = 'cd-summary';
    wrap.innerHTML =
      '<div class="cd-summary__row">' +
        '<span class="cd-summary__label">Общо</span>' +
        '<span id="cd-sum-subtotal" class="cd-summary__value">€0,00</span>' +
      '</div>' +
      '<div class="cd-summary__row">' +
        '<span class="cd-summary__label">Доставка</span>' +
        '<span id="cd-sum-shipping" class="cd-summary__value">Изчислява се при поръчка</span>' +
      '</div>' +
      '<div class="cd-summary__row cd-summary__row--discount" id="cd-sum-discount-row" style="display:none;">' +
        '<span class="cd-summary__label">Отстъпка</span>' +
        '<span id="cd-sum-discount" class="cd-summary__value">- €0,00</span>' +
      '</div>';

    footer.insertBefore(wrap, totalRow || footer.firstChild);

    sumSubtotal    = $('#cd-sum-subtotal');
    sumShippingVal = $('#cd-sum-shipping');
    sumDiscountRow = $('#cd-sum-discount-row');
    sumDiscountVal = $('#cd-sum-discount');
  }

  // Разбивка над бутона за поръчка (Общо / Доставка / Отстъпка) — mazno стил.
  // Всичко се чете директно от /cart.js, за да е винаги в синхрон с реалната количка.
  function renderSummary(c) {
    // Показваме редовната стойност на продуктите плюс реалната Shopify отстъпка.
    // compare-at намалението е само представяне; сумата за плащане не се променя.
    var original = (typeof c.original_total_price === 'number') ? c.original_total_price : c.total_price;
    (c.items || []).forEach(item => {
      const compareAt = compareAtFor(item);
      if (compareAt) original += (compareAt - item.original_price) * item.quantity;
    });
    var discount = Math.max(0, original - c.total_price);

    if (sumSubtotal) sumSubtotal.textContent = formatMoney(original);

    // Доставка: "Безплатно" при достигнат праг, иначе се смята на checkout.
    if (sumShippingVal) {
      var reached = c.total_price >= getThreshold();
      sumShippingVal.textContent = reached ? 'Безплатно' : 'Изчислява се при поръчка';
    }

    // Ред за отстъпка се показва само когато реално има отстъпка (> 0).
    if (sumDiscountRow) {
      if (discount > 0) {
        sumDiscountRow.style.display = '';
        if (sumDiscountVal) sumDiscountVal.textContent = '- ' + formatMoney(discount);
      } else {
        sumDiscountRow.style.display = 'none';
      }
    }
  }

  function showSkeleton() {
    if (!itemsWrap) return;
    // Ако вече има нарисувани редове, не ги заменяме със скелет — иначе бутоните
    // изчезват, докато клиентът кликa, и съдържанието премигва при всяко обновяване.
    if ($('.cd-item', itemsWrap)) return;
    itemsWrap.innerHTML = [1, 2, 3].map(() => `
      <div class="cd-skeleton">
        <div class="cd-skeleton__img"></div>
        <div class="cd-skeleton__lines">
          <div class="cd-skeleton__line"></div>
          <div class="cd-skeleton__line cd-skeleton__line--short"></div>
        </div>
      </div>`).join('');
  }

  /* ── qty / remove handlers ────────────── */
  // Debounce map: variant_id -> { timer } — при бързо повтарящо се кликане на +/- за
  // един и същи ред пращаме само ЕДНА мрежова заявка (за финалното количество) вместо
  // по една заявка на клик.
  //
  // ВАЖНО: всичко тук се води по variant_id, НЕ по line key. Shopify сменя ключа на
  // реда при всяка промяна на количеството, когато има автоматична отстъпка върху
  // количката. Ключ, запомнен в момента на клика, е вече невалиден, когато заявката
  // тръгне → 400 → кликът се губи. Затова ключът се взима чак при изпращане.
  const qtyDebounce = new Map();
  const QTY_DEBOUNCE_MS = 250;

  function itemElFor(vid) {
    return itemsWrap ? $('.cd-item[data-variant-id="' + vid + '"]', itemsWrap) : null;
  }

  function onQtyClick(e) {
    const btn    = e.currentTarget;
    const action = btn.dataset.action;
    const itemEl = btn.closest('.cd-item');
    if (!itemEl) return;
    const vid    = String(itemEl.dataset.variantId);

    const qtyEl  = $('.cd-item__qty-num', itemEl);
    const shown  = parseInt(qtyEl.textContent, 10);
    let qty      = pendingQty.has(vid) ? pendingQty.get(vid) : (Number.isFinite(shown) ? shown : 0);

    qty = Math.max(action === 'increase' ? qty + 1 : qty - 1, 0);

    // Оптимистично показваме числото веднага и го помним като желано количество,
    // за да не го върне назад отговор на по-стара заявка.
    pendingQty.set(vid, qty);
    qtyEl.textContent = qty;

    // Лентата също се движи веднага — не чакаме отговор от Shopify. Веднага след
    // това /cart.js връща истината и презаписва стойността, ако се разминава.
    previewBundleBar();

    const pending = qtyDebounce.get(vid);
    if (pending) clearTimeout(pending.timer);

    const timer = setTimeout(() => {
      qtyDebounce.delete(vid);
      if (pendingQty.get(vid) === 0) {
        removeItem(vid);
      } else {
        updateCartItem(vid, qty);
      }
    }, QTY_DEBOUNCE_MS);

    qtyDebounce.set(vid, { timer });
  }

  function onRemoveClick(e) {
    const itemEl = e.currentTarget.closest('.cd-item');
    if (!itemEl) return;
    const vid = String(itemEl.dataset.variantId);
    const pending = qtyDebounce.get(vid);
    if (pending) { clearTimeout(pending.timer); qtyDebounce.delete(vid); }
    pendingQty.set(vid, 0);
    removeItem(vid);
  }

  async function removeItem(vid) {
    const itemEl = itemElFor(vid);
    if (itemEl) {
      itemEl.classList.add('is-removing');
      await new Promise(r => setTimeout(r, 250));
    }
    await updateCartItem(vid, 0);
  }

  // Текущият ред за даден вариант според последното известно състояние на количката.
  function findLine(vid) {
    if (!isValidCart(cart)) return null;
    for (let i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].variant_id) === String(vid)) return cart.items[i];
    }
    return null;
  }

  // Чакащата промяна е приключила само ако няма по-нов клик след нея.
  function settleQty(vid, want) {
    if (!qtyDebounce.has(vid) && pendingQty.get(vid) === want) pendingQty.delete(vid);
  }

  async function postChange(id, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(id), quantity: quantity }),
    });
    return res.json();
  }

  async function updateCartItem(vid, quantity) {
    vid = String(vid);
    return queueCartMutation(async () => {
      const myToken = ++cartRequestToken;
      // Ако междувременно е имало още кликове, пращаме най-новото желано количество.
      const want = pendingQty.has(vid) ? pendingQty.get(vid) : quantity;
      try {
        let line = findLine(vid);

        // Количката вече е в желаното състояние — няма нужда от заявка.
        if ((line && line.quantity === want) || (!line && want <= 0)) {
          settleQty(vid, want);
          renderCart();
          return;
        }

        // Ключът се взима СЕГА (след като предишните заявки са приключили), не от клика.
        let data = await postChange(line ? line.key : vid, want);

        if (!isValidCart(data)) {
          // Shopify отхвърли заявката (остарял ключ и т.н.). Взимаме реалната количка
          // и опитваме още веднъж с пресния ключ, вместо да изгубим клика.
          const fresh = await (await fetch('/cart.js')).json();
          if (isValidCart(fresh)) {
            cart = fresh;
            line = findLine(vid);
            data = (line && line.quantity !== want) ? await postChange(line.key, want) : fresh;
          }
        }

        // Read the canonical cart after a quantity change. Its current discount
        // allocation is the source for the displayed subtotal and total.
        if (isValidCart(data)) {
          try {
            const fresh = await (await fetch('/cart.js', { cache: 'no-store' })).json();
            cart = isValidCart(fresh) ? fresh : data;
          } catch (_) {
            cart = data;
          }
        }
        if (isValidCart(cart)) cart = await normalizePairDiscount(cart);
        settleQty(vid, want);
        if (myToken !== cartRequestToken) return; // defensive - should never trigger once queued
        renderCart();
      } catch (e) {
        console.error('[CartDrawer] updateCartItem error', e);
        settleQty(vid, want);
        // Мрежова грешка — презареждаме реалната количка, за да не остане ДОМ-ът
        // да лъже с оптимистично число, което така и не се запази в Shopify.
        try {
          const fresh = await (await fetch('/cart.js')).json();
          if (isValidCart(fresh)) { cart = fresh; renderCart(); }
        } catch (_) { if (isValidCart(cart)) renderItems(cart.items); }
      }
    });
  }

  function pairOfferState(c) {
    const offer = $('#cj-cart-upsell');
    if (!offer || !isValidCart(c)) return { eligible: false };
    const kitIds = new Set($$('[data-cj-kit-id]', offer).map(row => row.dataset.cjKitId));
    const kits = c.items.filter(item => kitIds.has(String(item.product_id)));
    const count = kits.reduce((sum, item) => sum + item.quantity, 0);
    let couples = false;
    try {
      couples = localStorage.getItem('cj_persona') !== 'relax' &&
        !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/relax\/?$/i.test(window.location.pathname);
    } catch (_) {}
    return { eligible: couples && count === 2, couples, count, kits, offer };
  }

  async function normalizePairDiscount(c) {
    const state = pairOfferState(c);
    if (!state.offer || (state.couples && state.count >= 3)) return c;
    const code = state.offer.dataset.discountCode;
    const codes = c.discount_codes || [];
    const hasCode = codes.some(entry => String(entry.code).toUpperCase() === code.toUpperCase());
    if (!hasCode && !(c.attributes && c.attributes._cj_pair_upsell)) return c;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const response = await fetch(root + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        discount: codes.filter(entry => String(entry.code).toUpperCase() !== code.toUpperCase()).map(entry => entry.code).join(','),
        attributes: { _cj_pair_upsell: '' }
      })
    });
    if (!response.ok) throw new Error('Не успяхме да обновим отстъпката.');
    const fresh = await (await fetch(root + 'cart.js', { cache: 'no-store' })).json();
    if (!isValidCart(fresh)) throw new Error('Невалидна количка след обновяване на отстъпката.');
    return fresh;
  }

  function updateCheckoutState() {
    const link = $('#cd-drawer .cd-footer__checkout');
    if (!link) return;
    const enabled = isValidCart(cart) && cart.item_count > 0 && cartBusyCount === 0 && pendingQty.size === 0;
    link.setAttribute('aria-disabled', String(!enabled));
    if (enabled) link.removeAttribute('tabindex');
    else link.setAttribute('tabindex', '-1');
  }

  function pairStatus(message, error) {
    const status = $('#cj-cu-status');
    if (!status) return;
    status.hidden = !message;
    status.textContent = message;
    status.classList.toggle('is-error', !!error);
  }

  let pairAdding = false;
  async function addPairUpsell(button) {
    if (pairAdding || button.disabled) return;
    pairAdding = true;
    const label = button.textContent;
    button.textContent = 'Добавяне…';
    const offer = $('#cj-cart-upsell');
    const buttons = offer ? $$('.cj-cu__add', offer) : [];
    const states = buttons.map(b => b.disabled);
    buttons.forEach(b => { b.disabled = true; });
    if (offer) offer.setAttribute('aria-busy', 'true');
    pairStatus('', false);
    try {
      await queueCartMutation(async () => {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const read = async () => {
          const response = await fetch(root + 'cart.js', { cache: 'no-store' });
          if (!response.ok) throw new Error('Не успяхме да обновим количката. Опитай отново.');
          const data = await response.json();
          if (!isValidCart(data)) throw new Error('Не успяхме да прочетем количката.');
          return data;
        };
        const post = async (path, body) => {
          const response = await fetch(root + path, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || 'Не успяхме да добавим комплекта.');
          return data;
        };
        const before = await read();
        const state = pairOfferState(before);
        if (!state.eligible) { cart = before; renderCart(); throw new Error('Предложението важи за точно 2 комплекта за двойки.'); }
        const code = state.offer.dataset.discountCode;
        const otherCodes = (before.discount_codes || []).filter(c => c.applicable && c.code !== code);
        const kitSubtotal = state.kits.reduce((sum, item) => sum + item.original_line_price, 0);
        const targetIncrease = Number(state.offer.dataset.offerCents);
        if (otherCodes.length || kitSubtotal !== 2798 || before.original_total_price - before.total_price !== 300 || targetIncrease !== 1000) {
          throw new Error('Офертата не се съчетава с текущите отстъпки. Комплектът не е добавен.');
        }
        const variantId = String(button.dataset.variantId);
        const previous = before.items.find(item => String(item.variant_id) === variantId);
        const previousQuantity = previous ? previous.quantity : 0;
        const previousCodes = (before.discount_codes || []).map(c => c.code).join(',');
        let added = false;
        let discountChanged = false;
        try {
          added = true;
          await post('cart/add.js', { id: variantId, quantity: 1 });
          discountChanged = true;
          await post('cart/update.js', { discount: code, attributes: { _cj_pair_upsell: '1' } });
          const after = await read();
          if (after.total_price !== before.total_price + targetIncrease || pairOfferState(after).count !== 3) {
            throw new Error('Цената 10 € не беше потвърдена. Добавянето е отменено.');
          }
          cart = after;
          await loadProductPrices(after.items);
          renderCart();
          pairStatus('✓ Комплектът е добавен. Общо: ' + formatMoney(after.total_price) + ' — точно +10 €.', false);
        } catch (error) {
          try {
            const fresh = await read();
            const line = fresh.items.find(item => String(item.variant_id) === variantId);
            if (added && line && line.quantity === previousQuantity + 1) {
              await post('cart/change.js', { id: line.key, quantity: previousQuantity });
            }
            if (discountChanged) await post('cart/update.js', { discount: previousCodes, attributes: { _cj_pair_upsell: before.attributes && before.attributes._cj_pair_upsell || '' } });
            cart = await read();
            renderCart();
          } catch (_) {
            throw new Error('Възникна проблем. Провери количествата и общата сума в количката преди поръчка.');
          }
          throw error;
        }
      });
    } catch (error) {
      pairStatus(error.message || 'Добавянето не е успешно. Опитай отново.', true);
    } finally {
      pairAdding = false;
      button.textContent = label;
      buttons.forEach((b, i) => { b.disabled = states[i]; });
      if (offer) offer.removeAttribute('aria-busy');
    }
  }

  /* ── upsell add ───────────────────────── */
  async function onUpsellAdd(e) {
    const btn       = e.currentTarget;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('is-adding');
    btn.textContent = '...';

    try {
      await queueCartMutation(async () => {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        if (res.ok) {
          await fetchCartInner(); // вече сме вътре в опашката — НЕ викаме fetchCart(), за да не се самозаключим
        }
      });
      btn.textContent = '✓ Добавено';
      setTimeout(() => { btn.textContent = '+ Добави'; btn.classList.remove('is-adding'); }, 1500);
    } catch (e) {
      btn.classList.remove('is-adding');
      btn.textContent = '+ Добави';
    }
  }

  /* ── discount ─────────────────────────── */
  async function applyDiscount() {
    if (!discountInput || !discountMsg) return;
    const code = discountInput.value.trim().toUpperCase();
    if (!code) return;

    discountMsg.textContent = '';
    discountMsg.className = 'cd-discount__message';
    discountBtn.disabled = true;
    discountBtn.textContent = '...';

    try {
      await queueCartMutation(async () => {
        // Apply via section rendering trick - most reliable approach
        // We update the cart attributes and let Shopify validate at checkout
        // The proper validation uses the discount_codes endpoint
        await fetch('/discount/' + encodeURIComponent(code), {
          method: 'GET',
          redirect: 'follow',
        });

        // Shopify redirects to / with discount cookie set if valid
        // We verify by fetching cart to see if discount applied
        const cartRes = await fetch('/cart.js');
        const freshCart = await cartRes.json();

        // Check if Shopify accepted it (discount_codes in cart)
        if (isValidCart(freshCart) && freshCart.cart_level_discount_applications && freshCart.cart_level_discount_applications.length > 0) {
          cart = freshCart;
          renderCart();
          discountMsg.textContent = '✓ Кодът е приложен!';
          discountMsg.className = 'cd-discount__message success';
        } else {
          // Fallback: store code in session, will apply at checkout
          // Set via cart note attribute
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { discount_code: code } }),
          });
          discountMsg.textContent = '✓ Кодът ще се приложи при поръчката.';
          discountMsg.className = 'cd-discount__message success';
        }
      });
    } catch (err) {
      discountMsg.textContent = '✗ Невалиден код. Провери отново.';
      discountMsg.className = 'cd-discount__message error';
    }

    discountBtn.disabled = false;
    discountBtn.textContent = 'Приложи';
  }

  /* ── listen for add-to-cart from theme ──── */
  function listenForCartUpdates() {
    // Dawn fires this event when items are added
    document.addEventListener('cart:updated', async () => {
      await fetchCart();
    });

    // Also hook into fetch calls that Dawn makes to /cart/add.js
    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
      const result = await originalFetch.apply(this, args);
      const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
      if (url.includes('/cart/add')) {
        result.clone().json().then(data => {
          if (data && !data.status) {
            // Успешно добавяне някъде из сайта (продуктова страница, quick-add
            // кръгче върху продуктова карта, upsell вътре в количката).
            // ПО ПОДРАЗБИРАНЕ количката НЕ се отваря: презареждаме я тихо, за
            // да е вярна при следващото отваряне, и разклащаме плаващия бутон.
            // Ако настройката в Theme Editor е включена, пазим старото
            // поведение с автоматично отваряне.
            if (getAutoOpen()) {
              openDrawer();
              // bump badge immediately
              if (badge) {
                badge.classList.remove('bump');
                void badge.offsetWidth;
                badge.classList.add('bump');
              }
            } else {
              fetchCart();
              // Ако количката вече е отворена, табът е скрит — няма какво да
              // тресем; съдържанието ё и без това се обновява от fetchCart().
              if (!isOpen) shakeCart();
            }
          }
        }).catch(() => {});
      }
      return result;
    };
  }

  /* ── helpers ──────────────────────────────── */
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\x22/g, '&quot;');
  }

  /* ── Bundle logic (CLAYJOY4/6/8) ──────── */

  function getBundleTier(count) {
    for (var t = 0; t < BUNDLE_TIERS.length; t++) {
      if (count >= BUNDLE_TIERS[t].minQty) return BUNDLE_TIERS[t];
    }
    return null;
  }

  // Взима наново всяка bundle препратка, която липсва ИЛИ вече не е в живия
  // документ. Theme Editor пре-рендерира секцията при всяка промяна на настройка
  // (shopify:section:load) — старите препратки тогава сочат към откачено DOM
  // дърво: кодът работи, но пише в елементи, които никой не вижда. Точно това
  // изглежда като „лентата стои сива и не расте“.
  function alive(el) { return el && document.contains(el); }

  function bindBundleRefs() {
    if (!alive(bundleBar))   bundleBar   = $('#cd-bundle-bar');
    if (!alive(bundleFill))  bundleFill  = $('#cd-bundle-fill');
    if (!alive(bundleTrack)) bundleTrack = $('.cd-bundle-track');
    if (!alive(bundleText))  bundleText  = $('#cd-bundle-text');
    if (!alive(bundleMs2))   bundleMs2   = $('#cd-ms-2');
    if (!alive(bundleMs4))   bundleMs4   = $('#cd-ms-4');
    if (!alive(bundleMs6))   bundleMs6   = $('#cd-ms-6');
    if (!alive(bundleMs8))   bundleMs8   = $('#cd-ms-8');
    return !!bundleBar;
  }

  // Изчислява процента на запълване: всеки кит = 1/8 = 12.5%.
  function bundlePct(count) {
    var c = Number.isFinite(count) ? count : 0;
    if (c < 0) c = 0;
    return Math.min(c / BUNDLE_MAX_KITS * 100, 100);
  }

  // Единственото място, което боядисва лентата. Пише едновременно на три нива,
  // за да не може нито един от тях да я направи невидим:
  //   1) CSS променливи (--cd-pct/--cd-fill/--cd-empty) върху #cd-bundle-bar —
  //      наследяват се надолу, така че работят дори ако вътрешните препратки са null
  //   2) inline style с !important върху самата лента — бие всеки външен CSS
  //   3) aria-valuenow за screen reader-и
  function paintBundleBar(pct, colors) {
    if (bundleBar) {
      bundleBar.style.setProperty('--cd-pct',   pct + '%');
      bundleBar.style.setProperty('--cd-fill',  colors.fill);
      bundleBar.style.setProperty('--cd-empty', colors.empty);
    }
    if (bundleTrack) {
      bundleTrack.style.setProperty('background', colors.empty, 'important');
      bundleTrack.setAttribute('aria-valuenow', String(Math.round(pct)));
    }
    if (bundleFill) {
      bundleFill.style.setProperty('width', pct + '%', 'important');
      bundleFill.style.setProperty('background', colors.fill, 'important');
      bundleFill.style.setProperty('display', 'block', 'important');
    }
  }

  // Оптимистично движение на лентата при клик на +/- преди мрежовата заявка.
  function previewBundleBar() {
    if (!bindBundleRefs()) return;
    var count = 0;
    $$('.cd-item__qty-num').forEach(function (el) {
      var n = parseInt(el.textContent, 10);
      if (Number.isFinite(n) && n > 0) count += n;
    });
    paintBundleBar(bundlePct(count), getProgressColors());
  }

  function updateBundleBar(items, totalCents) {
    if (!bindBundleRefs()) return;

    var list  = Array.isArray(items) ? items : [];
    var count = list.reduce(function(s, it) { return s + (it.quantity || 0); }, 0);
    var pct   = bundlePct(count);

    // Цветовете идват от Theme Editor → Cart Drawer → „Цвят на незапълнена лента“
    // и „Цвят на запълнена лента“. Никакви hardcode-нати hex стойности тук.
    var barColors = getProgressColors();
    paintBundleBar(pct, barColors);

    // Milestone dot & label colours (quantity tiers за отстъпки; доставката е по €)
    var shipCents   = getThreshold();
    var shipReached = totalCents >= shipCents;
    var ms = [
      { el: bundleMs2, reached: shipReached },
      { el: bundleMs4, reached: count >= 4 },
      { el: bundleMs6, reached: count >= 6 },
      { el: bundleMs8, reached: count >= BUNDLE_MAX_KITS },
    ];
    ms.forEach(function(m) {
      if (!m.el) return;
      var dot = m.el.querySelector('.cd-bundle-ms-dot');
      var lbl = m.el.querySelector('.cd-bundle-ms-label');
      if (dot) dot.classList.toggle('is-reached', m.reached);
      if (lbl) lbl.classList.toggle('is-reached', m.reached);
    });

    // Progress text
    if (!bundleText) return;
    bundleText.className = 'cd-bundle-text';

    if (count === 0) {
      bundleText.innerHTML = 'Добави продукти за поне <strong>' + formatMoney(shipCents) + '</strong> за безплатна доставка';
    } else if (!shipReached) {
      var remaining = formatMoney(shipCents - totalCents);
      bundleText.innerHTML = 'Добави още <strong>' + remaining + '</strong> за безплатна доставка';
    } else if (count < 4) {
      var need4 = 4 - count;
      bundleText.innerHTML = '&#x1F69A; Безплатна доставка! Добави <strong>' + need4 + (need4 === 1 ? ' кит' : ' кита') + '</strong> за €5 отстъпка';
      bundleText.classList.add('is-milestone');
    } else if (count < 6) {
      var need6 = 6 - count;
      bundleText.innerHTML = '&#x2713; €5 отстъпка! Добави <strong>' + need6 + (need6 === 1 ? ' кит' : ' кита') + '</strong> за €15';
      bundleText.classList.add('is-milestone');
    } else if (count < BUNDLE_MAX_KITS) {
      var need8 = BUNDLE_MAX_KITS - count;
      bundleText.innerHTML = '&#x2713; €15 отстъпка! Добави <strong>' + need8 + (need8 === 1 ? ' кит' : ' кита') + '</strong> за €30';
      bundleText.classList.add('is-milestone');
    } else {
      bundleText.innerHTML = '&#x2605; Максимална отстъпка от €30 отключена!';
      bundleText.classList.add('is-max');
    }
  }

  // Отстъпките за bundle (4/6/8 кита) вече са НАТИВНИ автоматични отстъпки в Shopify
  // (Amount off order, min qty 4/6/8 → €5/€15/€30). Shopify сам прилага най-добрия tier
  // от страна на сървъра — БЕЗ код и БЕЗ /discount/ заявка. Затова тук няма нищо за правене.
  // Пази се като no-op, за да не чупим извикването от renderCart(); реалната отстъпка се
  // отразява в /cart.js и се показва през renderSummary() (разбивката над „Поръчай“).
  function applyBundleDiscount(itemCount) {
    return;
  }

  function initBundleToggle() {
    if (!bundleToggle || bundleToggle.dataset.cdBound === '1') return;
    bundleToggle.dataset.cdBound = '1';
    bundleToggle.addEventListener('click', function() {
      bundleOpen = !bundleOpen;
      if (bundlePanel) {
        bundlePanel.classList.toggle('is-open', bundleOpen);
        bundlePanel.setAttribute('aria-hidden', String(!bundleOpen));
      }
      if (bundleChevron) bundleChevron.classList.toggle('is-open', bundleOpen);
      bundleToggle.setAttribute('aria-expanded', String(bundleOpen));
    });
  }

  /* ── init ──────────────────────────────── */
  window.addEventListener('storage', function (event) {
    if (event.key === 'cj_persona' || event.key === null) renderCart();
  });
  window.addEventListener('pageshow', function () { renderCart(); });

  let fetchHooked = false;

  function init() {
    drawer       = $('#cd-drawer');
    overlay      = $('#cd-overlay');
    floatBtn     = $('#cd-float-btn');
    badge        = $('#cd-badge');
    itemsWrap    = $('#cd-items');
    progressFill = $('#cd-progress-fill');
    progressText = $('#cd-progress-text');
    progressTruck= $('#cd-progress-truck');
    totalAmount  = $('#cd-total-amount');
    discountInput= $('#cd-discount-input');
    discountBtn  = $('#cd-discount-btn');
    discountMsg  = $('#cd-discount-msg');
    upsellScroll = $('#cd-upsell-scroll');

    /* Summary (Общо / Доставка / Отстъпка) — вгражда се през JS, за да остане
       core секцията cd-cart-drawer.liquid непокътната (по-нисък риск). */
    buildSummaryDOM();

    /* Bundle */
    bundleBar     = null;
    bundleFill    = null;
    bundleTrack   = null;
    bundleText    = null;
    bundleMs2     = null;
    bundleMs4     = null;
    bundleMs6     = null;
    bundleMs8     = null;
    bindBundleRefs();
    bundleToggle  = $('#cd-bnd-toggle');
    bundlePanel   = $('#cd-bnd-panel');
    bundleChevron = $('#cd-bnd-chev');
    bundleOpen    = false;
    initBundleToggle();

    if (!drawer) return;

    // open
    if (floatBtn && floatBtn.dataset.cdBound !== '1') {
      floatBtn.dataset.cdBound = '1';
      floatBtn.addEventListener('click', openDrawer);
    }
// Header cart icon → open the same custom floating cart drawer
if (!init._headerCartBound) {
  init._headerCartBound = true;

  document.addEventListener('click', function (e) {
    const headerCart = e.target.closest('#cart-icon-bubble');
    if (!headerCart) return;

    e.preventDefault();
    openDrawer();
  });
}
    // close (capture phase, so upstream stopPropagation cannot swallow this)
    if (overlay && overlay.dataset.cdBound !== '1') {
      overlay.dataset.cdBound = '1';
      overlay.addEventListener('click', closeDrawer, true);
    }
    const closeBtn = $('#cd-close-btn');
    if (closeBtn && closeBtn.dataset.cdBound !== '1') {
      closeBtn.dataset.cdBound = '1';
      closeBtn.addEventListener('click', closeDrawer);
    }

    // escape key
    if (!init._escBound) {
      init._escBound = true;
      document.addEventListener('keydown', e => {
        if (!isOpen || !drawer) return;
        const active = document.activeElement;
        const owner = active && active.closest('[role="dialog"], dialog');
        if (owner && owner !== drawer) return;
        if (e.key === 'Escape') { closeDrawer(); return; }
        if (e.key !== 'Tab') return;
        const focusable = $$('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', drawer)
          .filter(el => el.getClientRects().length && el.getAttribute('aria-disabled') !== 'true');
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (!first) return;
        if (!drawer.contains(active) || (!e.shiftKey && active === last) || (e.shiftKey && active === first)) {
          e.preventDefault();
          (e.shiftKey ? last : first).focus();
        }
      });
    }

    // discount
    if (discountBtn && discountBtn.dataset.cdBound !== '1') {
      discountBtn.dataset.cdBound = '1';
      discountBtn.addEventListener('click', applyDiscount);
    }
    if (discountInput && discountInput.dataset.cdBound !== '1') {
      discountInput.dataset.cdBound = '1';
      discountInput.addEventListener('keydown', e => {
        if (e.key === 'Enter') applyDiscount();
      });
    }

    const checkout = $('.cd-footer__checkout', drawer);
    if (checkout && checkout.dataset.cjGuard !== '1') {
      checkout.dataset.cjGuard = '1';
      checkout.addEventListener('click', event => {
        if (checkout.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    }
    updateCheckoutState();

    const pairOffer = $('#cj-cart-upsell');
    if (pairOffer && pairOffer.dataset.cjBound !== '1') {
      pairOffer.dataset.cjBound = '1';
      pairOffer.addEventListener('click', event => {
        const button = event.target.closest('.cj-cu__add');
        if (button) addPairUpsell(button);
      });
    }

    // upsell buttons (delegated - rendered dynamically)
    if (upsellScroll && upsellScroll.dataset.cdBound !== '1') {
      upsellScroll.dataset.cdBound = '1';
      upsellScroll.addEventListener('click', e => {
        const btn = e.target.closest('.cd-upsell__card-btn');
        if (btn) onUpsellAdd({ currentTarget: btn });
      });
    }

    // listen for Dawn cart updates — само веднъж, за да не увиваме window.fetch
    // многократно при пре-рендер от Theme Editor.
    if (!fetchHooked) {
      fetchHooked = true;
      listenForCartUpdates();
    }

    // Начално състояние: badge + лентата, за да е вярна лентата още преди
    // първото отваряне на количката (и веднага след пре-рендер в Customize).
    queueCartMutation(fetchCartInner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme Editor: при всяка промяна на настройка Shopify подменя HTML-а на секцията.
  // Пре-инициализираме, за да не останат препратките към откаченото старо дърво —
  // така новите цветове/праг се виждат веднага в Customize, без презареждане.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.sectionId && !$('#cd-drawer')) return;
    init();
  });

})();




